import React from "react";
import Datatable from "../../../core/common/dataTable";
import { cellWidth } from "../../../core/methods/tableCellWidth";
import "./reports-breakdown.scss";

export const dataSource = [
  {
    key: "1",
    month: "February-2026",
    totalReports: 24,
    stop: 0,
    green: 24,
    red: 0,
    yellow: 0,
    orange: 0,
  },
  {
    key: "2",
    month: "March-2026",
    totalReports: 168,
    stop: 0,
    green: 157,
    red: 2,
    yellow: 7,
    orange: 2,
  },
  {
    key: "3",
    month: "April-2026",
    totalReports: 200,
    stop: 0,
    green: 173,
    red: 5,
    yellow: 9,
    orange: 13,
  },
  {
    key: "4",
    month: "May-2026",
    totalReports: 127,
    stop: 0,
    green: 101,
    red: 2,
    yellow: 7,
    orange: 17,
  },
];

const ColorCode = () => {
  const columns = [
    {
      title: "Months",
      dataIndex: "month",
      key: "month",
      onCell: () => cellWidth(150),
      render: (text: string) => (
        <div className="rb-month-cell">
          <i className="ti ti-calendar-event" />
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Total Reports",
      dataIndex: "totalReports",
      key: "totalReports",
      align: "center",
      render: (text: number) => <span className="rb-value-strong">{text}</span>,
    },
    {
      title: "Stop",
      dataIndex: "stop",
      key: "stop",
      align: "center",
      render: (text: number) => (
        <span className="rb-color-pill rb-color-pill--stop">{text}</span>
      ),
    },
    {
      title: "Green",
      dataIndex: "green",
      key: "green",
      align: "center",
      render: (text: number) => (
        <span className="rb-color-pill rb-color-pill--green">{text}</span>
      ),
    },
    {
      title: "Red",
      dataIndex: "red",
      key: "red",
      align: "center",
      render: (text: number) => (
        <span className="rb-color-pill rb-color-pill--red">{text}</span>
      ),
    },
    {
      title: "Yellow",
      dataIndex: "yellow",
      key: "yellow",
      align: "center",
      render: (text: number) => (
        <span className="rb-color-pill rb-color-pill--yellow">{text}</span>
      ),
    },
    {
      title: "Orange",
      dataIndex: "orange",
      key: "orange",
      align: "center",
      render: (text: number) => (
        <span className="rb-color-pill rb-color-pill--orange">{text}</span>
      ),
    },
  ];

  return (
    <div className="rb-module">
      {/* select filter */}
      <div className="rb-filter-card">
        <div className="rb-filter-card__head">
          <span className="rb-filter-card__icon">
            <i className="ti ti-filter" />
          </span>
          <div>
            <p className="rb-filter-card__title">Filters</p>
            <p className="rb-filter-card__subtitle">
              Choose the year to review its color-code breakdown
            </p>
          </div>
        </div>
        <div className="row gx-3">
          <div className="col-6 col-sm-4 col-md-3 rb-select-group">
            <label htmlFor="yearSelect" className="rb-field-label">
              Select Year
            </label>
            <select className="form-select" id="yearSelect" name="year">
              <option value="2026">2026</option>
              <option value="2025">2025</option>
              <option value="2024">2024</option>
              <option value="2023">2023</option>
            </select>
          </div>
        </div>
      </div>
      {/* /select filter */}

      {/* Table */}
      <div className="rb-table-card mt-3">
        <div className="rb-table-card__head">
          <div>
            <p className="rb-table-card__title">Report Color Code</p>
            <p className="rb-table-card__subtitle">
              Final report status distribution by month
            </p>
          </div>
        </div>
        <div className="rb-table-wrap">
          <Datatable columns={columns} dataSource={dataSource} />
        </div>
      </div>

      <div className="rb-note-card">
        <span className="rb-note-card__icon">
          <i className="ti ti-info-circle" />
        </span>
        <div>
          <p className="rb-note-card__title">Note</p>
          <ul className="rb-note-card__list">
            <li>1. Only closed and final cases will reflect here.</li>
            <li>
              2. Stopped cases where all checks are stopped will reflect here.
            </li>
            <li>
              3. Partial checks stopped in a case will reflect in track case
              progress stopped tab.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ColorCode;


// import React from "react";
// import Datatable from "../../../core/common/dataTable";
// import { cellWidth } from "../../../core/methods/tableCellWidth";

// export const dataSource = [
//   {
//     key: "1",
//     month: "February-2026",
//     totalReports: 24,
//     stop: 0,
//     green: 24,
//     red: 0,
//     yellow: 0,
//     orange: 0,
//   },
//   {
//     key: "2",
//     month: "March-2026",
//     totalReports: 168,
//     stop: 0,
//     green: 157,
//     red: 2,
//     yellow: 7,
//     orange: 2,
//   },
//   {
//     key: "3",
//     month: "April-2026",
//     totalReports: 200,
//     stop: 0,
//     green: 173,
//     red: 5,
//     yellow: 9,
//     orange: 13,
//   },
//   {
//     key: "4",
//     month: "May-2026",
//     totalReports: 127,
//     stop: 0,
//     green: 101,
//     red: 2,
//     yellow: 7,
//     orange: 17,
//   },
// ];

// const ColorCode = () => {
//   const columns = [
//     {
//       title: "Months",
//       dataIndex: "month",
//       key: "month",
//       onCell: () => cellWidth(150),
//     },
//     {
//       title: "Total Reports",
//       dataIndex: "totalReports",
//       key: "totalReports",
//       align: "center",
//     },
//     {
//       title: "Stop",
//       dataIndex: "stop",
//       key: "stop",
//       align: "center",
//     },
//     {
//       title: "Green",
//       dataIndex: "green",
//       key: "green",
//       align: "center",
//     },
//     {
//       title: "Red",
//       dataIndex: "red",
//       key: "red",
//       align: "center",
//     },
//     {
//       title: "Yellow",
//       dataIndex: "yellow",
//       key: "yellow",
//       align: "center",
//     },
//     {
//       title: "Orange",
//       dataIndex: "orange",
//       key: "orange",
//       align: "center",
//     },
//   ];

//   return (
//     <div className="card border p-3">
//       <div className="mb-3 col-sm-6 col-md-4">
//         <label htmlFor="yearSelect" className="form-label">
//           Select Year
//         </label>
//         <select className="form-select" id="yearSelect" name="year">
//           <option value="2026">2026</option>
//           <option value="2025">2025</option>
//           <option value="2024">2024</option>
//           <option value="2023">2023</option>
//         </select>
//       </div>
//       <Datatable columns={columns} dataSource={dataSource} />
//       <div className="mt-4 ps-2">
//         <h5>Note: -</h5>
//         <ul className="mt-2">
//           <li className="pb-1">
//             1. Only closed and final cases will reflect here.
//           </li>
//           <li className="pb-1">
//             2. Stopped cases where all checks are stopped will reflect here.
//           </li>
//           <li className="pb-1">
//             3. Partial checks stopped in a case will reflect in track case
//             progress stopped tab.
//           </li>
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default ColorCode;
